var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, no-var, react/jsx-closing-bracket-location, react/jsx-indent-props, react/sort-comp, space-infix-ops */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var Changeable = require("../mixins/changeable.jsx");
var EditorJsonify = require("../mixins/editor-jsonify.jsx");

var BlurInput = require("react-components/blur-input.jsx");
var PropCheckBox = require("../components/prop-check-box.jsx");

/**
 * This is used for editing a name/value pair.
 */
var PairEditor = React.createClass({
    displayName: "PairEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        name: React.PropTypes.string,
        value: React.PropTypes.string
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            name: "",
            value: ""
        };
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    render: function render() {
        return React.createElement(
            "fieldset",
            null,
            React.createElement(
                "label",
                null,
                "Name:",
                React.createElement(BlurInput, {
                    value: this.props.name,
                    onChange: this.change("name")
                })
            ),
            React.createElement(
                "label",
                null,
                "Value:",
                React.createElement(BlurInput, {
                    value: this.props.value,
                    onChange: this.change("value")
                })
            )
        );
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

/**
 * This is used for editing a set of name/value pairs.
 */
var PairsEditor = React.createClass({
    displayName: "PairsEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        pairs: React.PropTypes.arrayOf(React.PropTypes.shape({
            name: React.PropTypes.string,
            value: React.PropTypes.string
        })).isRequired
    }),

    render: function render() {
        var _this = this;

        var editors = _.map(this.props.pairs, function (pair, i) {
            return React.createElement(PairEditor, {
                key: i,
                name: pair.name,
                value: pair.value,
                onChange: _this.handlePairChange.bind(_this, i)
            });
        });
        return React.createElement(
            "div",
            null,
            editors
        );
    },

    change: function change() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return Changeable.change.apply(this, args);
    },


    handlePairChange: function handlePairChange(pairIndex, pair) {
        // If they're both non empty, add a new one
        var pairs = this.props.pairs.slice();
        pairs[pairIndex] = pair;

        var lastPair = pairs[pairs.length - 1];
        if (lastPair.name && lastPair.value) {
            pairs.push({ name: "", value: "" });
        }
        this.change("pairs", pairs);
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

/**
 * This is the main editor for this widget, to specify all the options.
 */
var IframeEditor = React.createClass({
    displayName: "IframeEditor",

    propTypes: _extends({}, Changeable.propTypes),

    getDefaultProps: function getDefaultProps() {
        return {
            url: "",
            settings: [{ name: "", value: "" }],
            width: "400",
            height: "400",
            allowFullScreen: false,
            allowTopNavigation: false
        };
    },

    change: function change() {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
        }

        return Changeable.change.apply(this, args);
    },


    render: function render() {
        return React.createElement(
            "div",
            null,
            React.createElement(
                "div",
                { style: { fontWeight: "bold", textAlign: "center" } },
                "This widget is deprecated! ",
                React.createElement("br", null),
                "Try using the Video or CS Program widgets instead."
            ),
            React.createElement(
                "label",
                null,
                "Url or Program ID:",
                React.createElement(BlurInput, {
                    name: "url",
                    value: this.props.url,
                    onChange: this.change("url")
                })
            ),
            React.createElement("br", null),
            React.createElement(
                "label",
                null,
                "Settings:",
                React.createElement(PairsEditor, {
                    name: "settings",
                    pairs: this.props.settings,
                    onChange: this.handleSettingsChange
                })
            ),
            React.createElement("br", null),
            React.createElement(
                "label",
                null,
                "Width:",
                React.createElement(BlurInput, {
                    name: "width",
                    value: this.props.width,
                    onChange: this.change("width")
                })
            ),
            React.createElement(
                "label",
                null,
                "Height:",
                React.createElement(BlurInput, {
                    name: "height",
                    value: this.props.height,
                    onChange: this.change("height")
                })
            ),
            React.createElement(PropCheckBox, {
                label: "Allow full screen",
                allowFullScreen: this.props.allowFullScreen,
                onChange: this.props.onChange
            }),
            React.createElement("br", null),
            React.createElement(PropCheckBox, {
                label: "Allow iframe content to redirect the page",
                allowTopNavigation: this.props.allowTopNavigation,
                onChange: this.props.onChange
            })
        );
    },

    handleSettingsChange: function handleSettingsChange(settings) {
        this.change({ settings: settings.pairs });
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

module.exports = IframeEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/iframe-editor.jsx
 ** module id = 113
 ** module chunks = 0 1
 **/